var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:( _obj = { 'pb-float-button': true }, _obj[_vm.latlng] = true, _obj[_vm.color] = true, _obj.fab = _vm.fab, _obj ),style:(_vm.multiverse),attrs:{"title":_vm.title},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }